export default __webpack_public_path__ + "static/media/avatar.d3230ea9.svg";